export default __webpack_public_path__ + "static/logo-bc5476bd372a1715dc7680eed2013e9c.png";